var render = function render(){
  var _vm$userDetail, _vm$userDetail$positi, _vm$userDetail2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_vm._v(" " + _vm._s((_vm$userDetail = _vm.userDetail) === null || _vm$userDetail === void 0 ? void 0 : _vm$userDetail.name) + " ")]), _c('small', {
    staticClass: "mb-0"
  }, [_vm._v(_vm._s((_vm$userDetail$positi = (_vm$userDetail2 = _vm.userDetail) === null || _vm$userDetail2 === void 0 ? void 0 : _vm$userDetail2.position) !== null && _vm$userDetail$positi !== void 0 ? _vm$userDetail$positi : '-') + " ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }